import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { AssetRegisterAttachmentModel } from '../../../../../../models/aggregates/erp/asset-register';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa } from '../../shared/api-visa.model';

@Injectable({
  providedIn: 'root'
})
export class AssetRegisterAttachmentService extends BaseApiTemplateService<AssetRegisterAttachmentModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'fa/fixed-asset-registers/attachments/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'fa/fixed-asset-registers/attachments/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'fa/fixed-asset-registers/attachments/backoffice-ep';
    this.httpClient = http;
  }

  addAttachement(formData: FormData, farHdrGuid, visa: ApiVisa) {
    let url = this.apiUrl + '/file/' + farHdrGuid + '/create';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + farHdrGuid + '/create?fixedAssetGuid=' + farHdrGuid;
    }
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  deleteAttachmentByGuid(attachmentGuid: string, visa: ApiVisa) {
    let url = this.apiUrl + attachmentGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/' + attachmentGuid;
    }
    return this.httpClient.delete(url, this.getHttpHeader(visa));
  }

}
